import React, { useEffect, useState, useCallback } from "react";
import pdfWorker from "pdfjs-dist/build/pdf.worker.entry";
import * as pdfjs from "pdfjs-dist/es5/build/pdf";
import { Document, Page } from "react-pdf";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Row } from "../../common/columns";
import Loader from "../../common/loader/Loader";
import {
  faChevronCircleRight,
  faChevronCircleLeft,
  faSearchPlus,
  faSearchMinus,
} from "@fortawesome/free-solid-svg-icons";
import { cleanJoin } from "../../utils/stringUtil";
import { useTranslation } from "react-i18next";
import {
  isDesktop,
  isWideScreen,
  isFullHD,
  isTouch,
  isTablet,
  is2K,
  is1080p,
  isMobile,
  isMobileSmall,
} from "../../utils/screenUtil";

pdfjs.GlobalWorkerOptions.workerSrc = pdfWorker;

function Pdf({ path }) {
  const [numPages, setNumPage] = useState(null);
  const [pageNumber, setPageNumber] = useState(1);
  const { t } = useTranslation();

  const [scale, setScale] = useState();

  const [width, setWidth] = useState({ innerWidth: window.innerWidth });

  const [zoomCounter, setZoomCounter] = useState(0);

  useEffect(() => {
    function handleResize() {
      setWidth({ innerWidth: window.innerWidth });
    }
    window.addEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    if (is2K()) {
      setScale(1.8);
    } else if (is1080p()) {
      setScale(1.6);
    } else if (isFullHD()) {
      setScale(1.5);
    } else if (isWideScreen()) {
      setScale(1.4);
    } else if (isDesktop()) {
      setScale(1.2);
    } else if (isTablet()) {
      setScale(1);
    } else if (isMobile()) {
      setScale(0.6);
    } else if (isMobileSmall()) {
      setScale(0.4);
    }
  }, [width]);

  const zoomIn = () => {
    setZoomCounter(0);
    setZoomCounter(zoomCounter + 1);
    if (zoomCounter < 3) {
      setScale(scale + 0.2);
    } else if (zoomCounter === 3) {
      setZoomCounter(3);
    }
  };

  const zoomOut = () => {
    setZoomCounter(0);
    setZoomCounter(zoomCounter - 1);
    if (zoomCounter > -3) {
      setScale(scale - 0.2);
    } else if (zoomCounter === -3) {
      setZoomCounter(-3);
    }
  };

  const documentLoadHandler = ({ numPages }) => {
    setNumPage(numPages);
    setPageNumber(1);
  };

  const changePage = (offset) => {
    setPageNumber((prevPageNumber) => prevPageNumber + offset);
  };

  const previousPage = () => {
    changePage(-1);
  };

  const nextPage = () => {
    changePage(1);
  };

  const canvasRef = useCallback((canvas) => {
    if (canvas !== null) {
      const canvas = document.getElementsByTagName("CANVAS");
      canvas[0].attributes[0].nodeValue += " box is-centered is-full";
      canvas[0].style +=
        " transform: translate(-50%, -50%); top: 50%; left: 50%; margin-left: auto; margin-right: auto; display: block;";
    }
  }, []);

  return (
    <div className="is-centered is-full">
      <div className="is-pulled-right mt-1 mr-5">
        <FontAwesomeIcon
          className={cleanJoin("has-color-grey", "is-clickable")}
          icon={faSearchMinus}
          size="1x"
          onClick={zoomOut}
        />
        <FontAwesomeIcon
          className={cleanJoin("has-color-grey", "is-clickable")}
          icon={faSearchPlus}
          size="1x"
          onClick={zoomIn}
        />
      </div>
      <Row className="is-centered mt-3 ml-6">
        <FontAwesomeIcon
          className={cleanJoin(
            "has-color-grey",
            "mt-1",
            pageNumber <= 1 ? "is-hidden" : "",
            "is-clickable"
          )}
          icon={faChevronCircleLeft}
          size="1x"
          onClick={previousPage}
        />
        <p className="mx-6">
          {t("requests.preview.page")} {pageNumber || (numPages ? 1 : "--")}/{numPages || "--"}
        </p>
        <FontAwesomeIcon
          className={cleanJoin(
            "has-color-grey",
            "mt-1",
            pageNumber >= numPages ? "is-hidden" : "",
            "is-clickable"
          )}
          icon={faChevronCircleRight}
          size="1x"
          onClick={nextPage}
        />
      </Row>

      <Document
        file={path}
        onLoadSuccess={documentLoadHandler}
        renderMode="canvas"
        loading={""}
        noData={""}
      >
        <Page
          pageNumber={pageNumber}
          className={cleanJoin("is-centered", "is-full")}
          scale={scale}
          canvasRef={canvasRef}
          loading={""}
          noData={""}
        />
      </Document>
    </div>
  );
}

export default Pdf;
